import noAuth from "@/router/guards/noAuth.ts";
import auth from "@/router/guards/auth.ts";
import { type RouteRecordRaw } from 'vue-router';

const Login = () => import('@/views/login/Login.vue');
const User = () => import('@/views/user/User.vue');

/*
 | ------------------------------------------------------------------------------------
 |                      Login Routes
 | ------------------------------------------------------------------------------------
 */
export const loginRoutes: RouteRecordRaw[] = [
  {
    path: '/login',
    name: 'Login Page',
    component: Login,
    beforeEnter: noAuth
  },
  {
    path: '/user',
    name: 'User Page',
    component: User,
    beforeEnter: auth
  }
];
